// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__kVq08","dark":"Navbar_dark__OecNo","light":"Navbar_light__Ipkf2","active":"Navbar_active__Obrg+","link":"Navbar_link__J70aS"};